import { ComponentPropsWithRef, forwardRef, memo } from "react";
import classNames from "classnames";

import styles from "./styles.module.scss";

export type OverlayBackgroundType = "blurred" | "gradient" | "none"

export type OverlayProps = ComponentPropsWithRef<"div"> & {
  backgroundType?: OverlayBackgroundType
}

export const Overlay = memo(forwardRef<HTMLDivElement, OverlayProps>((
  {
    children,
    backgroundType = "none",
    className,
    style,
    ...props
  }, ref) => (
  <div
    className={classNames(styles[backgroundType as keyof typeof styles], className)}
    style={{
      ...style,
      backgroundColor: undefined,
    }}
    {...props}
    ref={ref}
  >
    {children}
  </div>
)));